const compactFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  compactDisplay: "short",
  maximumFractionDigits: 1,
});

const NUMERIC_PATTERN = /^(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?$/;

function formatNumericString(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return "";

  const match = trimmed.match(/^([^0-9+-]*)([+-]?(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?)([^0-9]*)$/);
  if (!match) return null;

  const [, prefix, numericPart, suffix] = match;
  const normalized = numericPart.replace(/,/g, "");
  if (!NUMERIC_PATTERN.test(normalized.replace(/^[+-]/, ""))) return null;

  const parsed = Number(normalized);
  if (!Number.isFinite(parsed)) return null;

  return `${prefix}${compactFormatter.format(parsed)}${suffix}`;
}

export const formatCompactNumber = (value: unknown): string => {
  if (value == null) return "";
  if (Array.isArray(value)) return value.map((item) => formatCompactNumber(item)).join(", ");

  if (typeof value === "number") {
    if (!Number.isFinite(value)) return String(value);
    return compactFormatter.format(value);
  }

  const asString = String(value);
  const formatted = formatNumericString(asString);
  return formatted ?? asString;
};
